// Version : 1.0.0
// Author : AGALYA
const BasicDetailsActionType = {
	/** ***************** BASIC DETAILS ADD START *********************** */
	BASIC_DETAILS_ADD_START: 'basic_details_add_start',
	BASIC_DETAILS_ADD_SUCCESS: 'basic_details_add_success',
	BASIC_DETAILS_ADD_FAILURE: 'basic_details_add_failure',
	BASIC_DETAILS_ADD_RESPONSE_REST_START: 'basic_details_add_response_reset_start',
	BASIC_DETAILS_ADD_RESPONSE_CHANGED: 'basic_details_add_response_changed',
	/** ***************** BASIC DETAILS ADD END *********************** */
};

export default BasicDetailsActionType;
